import { Component } from "@angular/core";
import { AuthService, UserService } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import {faUsers, faAddressCard, faWallet, faList, faChartBar, faLink, faCommentAlt, faGlobe, faTable, faCogs, faCheckDouble } from '@fortawesome/free-solid-svg-icons';


@Component({
	selector: "app-sidebar",
	templateUrl: "./sidebar.component.html",
	styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent extends BaseComponent {
	faUsers = faUsers;
	faAddressCard=faAddressCard;
	faWallet = faWallet;
	faList = faList;
	faChartBar = faChartBar;
	faLink = faLink;
	faCommentAlt = faCommentAlt;
	faGlobe = faGlobe;
	faTable = faTable;
	faCogs = faCogs;
	faCheckDouble = faCheckDouble;

	pointsStr: string;
	learningLevel: string;

	constructor
	(
		private authService: AuthService,
		private userService: UserService,
		private notifierService: NotifierService,
		private router:Router
	)
	{
		super();
		$(document).ready(function () {
			$('#sidebarCollapse').on('click', function () {
				if($('#sidebar').hasClass('active')){
					$(".profile-name").show();
					$(".profile-avatar").show();
					$(".profile-points").show();
				}
				else{
					setTimeout(function () {
						$(".profile-name").hide();
						$(".profile-avatar").hide();
						$(".profile-points").hide();
					}, 10);
				}

				$('#sidebar').toggleClass('active');
			});

			var $window = $(window);

			function checkWidth() {
				var windowsize = $(window).width();
				if (windowsize < 800 && !$('#sidebar').hasClass('active')) {
					$('#sidebar').addClass('active');
				}
			}
			checkWidth();
			$(window).resize(checkWidth);
		});

		var t = this;
		t.pointsStr = "0";
		t.learningLevel ="";
		t.setLoading(true);
		this.userService.getUser()
			.then((resp) => {
				this.userService.currentUser = resp.data;
				t.setLoading(false);
			})
			.catch((error) => {
				console.error(error.error);
				t.setLoading(false);
				this.notifierService.notify('error', 'Пожалуйста выполните авторизацию');
				this.authService.logout();
			});
	}

	public logout():void {
		this.userService.logout();
	}

	public isSelectedPage(nameId:any):boolean{
		if(!nameId){
			return false;
		}
		var namePageList = location.pathname.split('/');
		var nameIdList = nameId.split('/');

		if (!!namePageList && namePageList.length > 0 &&
			!!nameIdList && nameIdList.length > 0) {
			for (let i = 0; i < nameIdList.length; i++) {

				if(namePageList.includes(nameId[i])){
					return true;
				}
				if (namePageList[i] != nameIdList[i]) {
					return false;
				}
			}
			return true;
		}
		return false;
	}

	public getRole():number {
		return this.userService.getRole();
	}

	public currentUser():any {
		return this.userService.currentUser;
	}



}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts